import { CloseButton, CloseButtonProps, HoverTooltip, TooltipPositions } from '@brandfolder/react';
import { FunctionComponent } from 'react';
import styled from 'styled-components';

interface AsideCloseButtonProps extends Omit<CloseButtonProps, 'aria-label' | 'icon'> {
  label: string;
  setOpen: (open: boolean) => void;
  tooltip: string;
}

const UnstyledAsideCloseButton: FunctionComponent<AsideCloseButtonProps> = (props) => {
  const { className, label, setOpen, tooltip, ...otherProps } = props;

  return (
    <HoverTooltip className={className} position={TooltipPositions.Right} text={tooltip}>
      <CloseButton
        {...otherProps}
        aria-label={label}
        fontIconProps={{
          iconSize: 14
        }}
        onClick={() => setOpen(false)}
      />
    </HoverTooltip>
  );
};

const StyledAsideCloseButton = styled(UnstyledAsideCloseButton)`
  &:after {
    z-index: 2;
  }

  &:before {
    background-color: #111;
    font-size: 12px;
    line-height: 18px;
    padding: 6px 8px;
  }

  .bf-button__close {
    background-color: #333;
    border-color: #333;
    color: #fff;
    height: 45px;
    min-height: 0;
    width: 45px;

    &:hover {
      background-color: #111;
      border-color: #111;
      color: #fff;
    }

    &:active {
      background-color: #111;
      border-color: #111;
      color: #fff;
    }

    &:focus-visible {
      background-color: #111;
      border-color: #111;
      color: #fff;
      outline-color: #999;
    }
  }
`;

export const AsideCloseButton: FunctionComponent<AsideCloseButtonProps> = (props) => {
  return <StyledAsideCloseButton {...props} />;
};
